import React from 'react'
import styled from 'styled-components'
import Typography from '../../../components/Typography'
import Button from '../../../components/Button/Button'
import { theme } from '../../../theme'

const PeopleStateView = ({
  title,
  description,
  actionLabel,
  onAction,
  actionVariant = 'brand'
}) => {
  return (
    <EmptyState>
      <EmptyContent>
        {title && (
          <Typography $variant="body-1-medium" color={theme.colors.defaultMain}>
            {title}
          </Typography>
        )}

        {description && (
          <Typography $variant="body-2-medium" color={theme.colors.defaultWeak}>
            {description}
          </Typography>
        )}

        {actionLabel && onAction && (
          <Button $variant={actionVariant} onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </EmptyContent>
    </EmptyState>
  )
}

export default PeopleStateView

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 180px;
  width: 100%;
  border: 1px dashed ${({ theme }) => theme.border.defaultSubtle};
  border-radius: ${({ theme }) => theme.radius.xs};
  background-color: ${({ theme }) => theme.fill.defaultSubtle};
`

const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.sizing.xs};
  max-width: 520px;
  padding: 0 ${({ theme }) => theme.sizing.sm};
`
